<template>
  <div class="box">
    <!-- 售电公司注册 -->
    <el-tabs type="border-card">
      <el-tab-pane label="售电公司注册">
        <div class="company">
          <div class="information-box">
            <div class="information">
              <p>
                用户名：
                <span>*</span>
              </p>
            </div>
            <input type="text" placeholder="用户名" name="username" id="username" v-model="username" />
          </div>
          <br />
          <div class="information-box">
            <div class="information">
              <p>
                企业名称：
                <span>*</span>
              </p>
            </div>
            <input
              type="text"
              placeholder="企业名称"
              name="companyName"
              id="companyName"
              v-model="companyName"
            />
          </div>
          <br />
          <div class="information-box">
            <div class="information">
              <p>
                所在省市：
                <span>*</span>
              </p>
            </div>
            <input
              type="text"
              placeholder="所在省市"
              name="companyAdress"
              id="companyAdress"
              v-model="companyAdress"
            />
          </div>
          <br />
          <div class="information-box">
            <div class="information">
              <p>
                手机号：
                <span>*</span>
              </p>
            </div>
            <input
              type="text"
              placeholder="手机号"
              name="phoneNumber"
              id="phoneNumber"
              v-model="phoneNumber"
            />
          </div>
          <br />
          <div class="information-box">
            <div class="information">
              <p>
                联系人姓名：
                <span>*</span>
              </p>
            </div>
            <input
              type="text"
              placeholder="联系人姓名"
              name="contactName"
              id="contactName"
              v-model="contactName"
            />
          </div>
          <br />
          <div class="information-box">
            <div class="information">
              <p>
                联系人职务：
                <span>*</span>
              </p>
            </div>
            <input
              type="text"
              placeholder="联系人职务"
              name="contactJob"
              id="contactJob"
              v-model="contactJob"
            />
          </div>
          <br />
          <div class="information-box">
            <div class="information">
              <p>
                密码：
                <span>*</span>
              </p>
            </div>
            <input
              type="password"
              placeholder="密码(不能使用空格)"
              name="password"
              id="password"
              v-model="password"
            />
          </div>
          <br />
          <div class="information-box">
            <div class="information">
              <p>
                确认密码：
                <span>*</span>
              </p>
            </div>
            <input
              type="password"
              placeholder="确认密码"
              name="passwordcheck"
              id="passwordcheck"
              v-model="passwordcheck"
              @blur="passwordValidate"
            />
            <span id="tishi"></span>
          </div>
          <br />
          <div class="information-box">
            <div class="information">
              <p>
                企业法人：
                <span>*</span>
              </p>
            </div>
            <input
              type="text"
              placeholder=" 企业法人"
              name="legalPerson"
              id="legalPerson"
              value="legal"
              v-model="legalPerson"
            />
          </div>
          <br />
          <div class="information-box">
            <div class="information">
              <p>
                法人电话：
                <span>*</span>
              </p>
            </div>
            <input
              type="text"
              placeholder="法人电话"
              name="legalPersonPhone"
              id="legalPersonPhone"
              value="tel"
              v-model="legalPersonPhone"
            />
          </div>
          <br />
          <div class="information-box aaa">
            <div class="information">
              <p>
                营业执照：
                <span>*</span>
              </p>
            </div>
            <!-- 新的 -->
            <el-upload
              class="avatar-uploader"
              action="/api/websitemanager_v1/ApiController/file"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :on-success="handleAvatarSuccess"
            >
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>

            <!-- <el-upload
              action="http://192.168.1.6:8070/ApiController/file"
              list-type="picture-card"
              :limit="1"
              :on-remove="handleRemove"
              :on-success="handleSuccess"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog> -->
          </div>
          <br />
          <div class="information-box">
            <button class="submit" @click="onSubmit()" v-preventReClick>注册</button>
          </div>
        </div>
      </el-tab-pane>
      <!-- 企业用户注册 -->
      <el-tab-pane label="企业用户注册">
        <div class="company">
          <div class="information-box">
            <div class="information">
              <p>
                用户名：
                <span>*</span>
              </p>
            </div>
            <input type="text" placeholder="用户名" v-model="usernames" />
          </div>
          <br />
          <div class="information-box">
            <div class="information">
              <p>
                企业名称：
                <span>*</span>
              </p>
            </div>
            <input type="text" placeholder="企业名称" v-model="enterpriseNames" />
          </div>
          <br />
          <div class="information-box">
            <div class="information">
              <p>
                所在省市：
                <span>*</span>
              </p>
            </div>
            <input type="text" placeholder="所在省市" v-model="enterpriseAdresses" />
          </div>
          <br />
          <div class="information-box">
            <div class="information">
              <p>
                手机号：
                <span>*</span>
              </p>
            </div>
            <input type="text" placeholder="手机号" v-model="phoneNumbers" />
          </div>
          <br />
          <div class="information-box">
            <div class="information">
              <p>
                联系人姓名：
                <span>*</span>
              </p>
            </div>
            <input type="text" placeholder="联系人姓名" v-model="contactNames" />
          </div>
          <br />
          <div class="information-box">
            <div class="information">
              <p>
                联系人职务：
                <span>*</span>
              </p>
            </div>
            <input type="text" placeholder="联系人职务" v-model="contactJobs" />
          </div>
          <br />
          <div class="information-box">
            <div class="information">
              <p>
                密码：
                <span>*</span>
              </p>
            </div>
            <input type="password" placeholder="密码(不能使用空格)" v-model="passwords" />
          </div>
          <br />
          <div class="information-box">
            <div class="information">
              <p>
                确认密码：
                <span>*</span>
              </p>
            </div>
            <input type="password" placeholder="确认密码" v-model="passwordchecks" />
          </div>
          <br />
          <div class="information-box">
            <button class="submit" @click="onAgainSubmit()" v-preventReClick>注册</button>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: "Register",
  data() {
    return {
      username: "",
      companyName: "",
      companyAdress: "",
      phoneNumber: "",
      contactName: "",
      contactJob: "",
      password: "",
      passwordcheck: "",
      legalPerson: "",
      legalPersonPhone: "",
      errorList: [],
      businessLicense: "",
      usernames: "",
      enterpriseNames: "",
      enterpriseAdresses: "",
      phoneNumbers: "",
      contactNames: "",
      contactJobs: "",
      passwords: "",
      passwordchecks: "",
      imageUrl: "", //新的
    };
  },
  methods: {
    handleAvatarSuccess(res, file) {
      console.log(file, "-00--");
      this.imageUrl = URL.createObjectURL(file.raw);
      this.businessLicense = file.response.msg
    },
    beforeAvatarUpload(file) {
        const isLt1M = file.size / 1024 / 1024 < 1;
        if (!isLt1M) {
            this.$message.error('营业执照大小不能超过 1MB!');
        }
        return  isLt1M;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      // this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleSuccess(response, file, fileList) {
      console.log(response);
      this.businessLicense = response.msg;
    },
    passwordValidate() {
      //  console.log('--0--')
      if (this.passwordcheck !== this.password) {
        this.$message({
          type: "info",
          message: "两次密码不匹配",
        });
      }
    },
    onSubmit() {
      console.log("注册");
      console.log(this.name);
      console.log(this.dialogImageUrl, "上传图片地址");
      console.log(this.businessLicense, "上传");
      console.log(this.imageUrl,'这是头像')
      let obj = {
        username: this.username,
        companyName: this.companyName,
        companyAdress: this.companyAdress,
        phoneNumber: this.phoneNumber,
        contactName: this.contactName,
        contactJob: this.contactJob,
        password: this.password,
        passwordcheck: this.passwordcheck,
        legalPerson: this.legalPerson,
        legalPersonPhone: this.legalPersonPhone,
        businessLicense: this.businessLicense,
        // businessLicense:this.imageUrl
      };
      if (
        this.username == "" ||
        this.companyName == "" ||
        this.companyAdress == "" ||
        this.phoneNumber == "" ||
        this.contactName == "" ||
        this.contactJob == "" ||
        this.password == "" ||
        this.passwordcheck == "" ||
        this.legalPerson == "" ||
        this.legalPersonPhone == "" ||
        this.imageUrl == ""
      ) {
        this.$message({
          type: "info",
          message: "必填项未填",
        });
      } else if (this.passwordcheck !== this.password) {
        this.$message({
          type: "info",
          message: "两次密码不匹配",
        });
      } else {
        this.$http
          .post("/api/websitemanager_v1/ApiController/electricityAdd", obj)
          .then((res) => {
            console.log(res);
            if (res.body.code == 200) {
              this.$message({
                type: "success",
                message: res.body.msg,
              });
              this.$router.push({ path: "/" });
            } else {
              this.$message({
                type: "info",
                message: res.body.msg,
              });
            }
          });
      }
    },
    onAgainSubmit() {
      console.log("企业用户注册");
      let obj = {
        username: this.usernames,
        enterpriseName: this.enterpriseNames,
        enterpriseAdress: this.enterpriseAdresses,
        phoneNumber: this.phoneNumbers,
        contactName: this.contactNames,
        contactJob: this.contactJobs,
        password: this.passwords,
        passwordchecks: this.passwordchecks,
      };
      if (
        this.usernames == "" ||
        this.enterpriseNames == "" ||
        this.enterpriseAdresses == "" ||
        this.phoneNumbers == "" ||
        this.contactNames == "" ||
        this.contactJobs == "" ||
        this.passwords == "" ||
        this.passwordchecks == ""
      ) {
        this.$message({
          type: "info",
          message: "必填项未填",
        });
      } else if (this.passwordchecks !== this.passwords) {
        this.$message({
          type: "info",
          message: "两次密码不匹配",
        });
      } else {
        this.$http
          .post("/api/websitemanager_v1/ApiController/enterpriseAdd", obj)
          .then((res) => {
            console.log(res);
            if (res.body.code == 200) {
              this.$message({
                type: "success",
                message: res.body.msg,
              });
              this.$router.push({ path: "/" });
            } else {
              this.$message({
                type: "info",
                message: res.body.msg,
              });
            }
          });
      }
    },
  },
};
</script>

<style>
.box {
  width: 80%;
  margin: 0 auto;
  position: relative;
}
.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  font-size: 16px;
}
.company {
  width: 65%;
  margin: 0 auto;
}
.information-box {
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-content: center;
}
.information {
  width: 20%;
  margin-top: 10px;
  margin-right: 10px;
}
.information p {
  text-align: right;
  font-weight: 600;
}
.information p span {
  color: red;
}
input {
  width: 80%;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding-left: 10px;
  font-size: 14px;
}
.select-file {
  margin-right: 60%;
}
.submit {
  width: 100%;
  height: 50px;
  margin-left: 100px;
  background-color: cornflowerblue;
  font-size: 18px;
  border-radius: 8px;
  border: 1px solid cornflowerblue;
}
.aaa {
  height: 200px;
}
input[type="file"] {
  display: none;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/Register.vue